<template>
<div style="height: 100%">
    <app-base-main parentTable no-padding class="rule-template-content">
      <template #filter-group>
        <app-filter-group @reset="$gjReset" @query="$gjNoticeQuery" :isBr="false">
          <gj-search-input
            v-model="filter.name"
            width="180px"
            placeholder="请输入模板名称"
           ></gj-search-input>
          <gj-creator-select
              v-model="filter.createUserId"
              placeholder="创建人"
          ></gj-creator-select>
         <gj-creator-select
              v-model="filter.updateUserId"
              placeholder="更新人"
          ></gj-creator-select>
        </app-filter-group>
      </template>
      <template  #operate-group>
        <gj-button type="primary" @click="add" v-if="$permission('adsStrategyTemplate:add')">添加模板</gj-button>
      </template>
      <template v-if="$permission('adsStrategyTemplate:add')" #tool-group>
        <gj-tool-group help  :helpName="helpName"></gj-tool-group>
      </template>
      <template #table>
        <gj-table
          ref="gjTable"
          adaptParent
          :index="false"
          name="rule-template"
          :show-overflow="false"
          :loading="loading"
          :data="tableData"
          :columns="columns"
          :pagination="pagination"
          @sort-change="$gjSortChange"
          @page-change="$gjNoticeQuery"
          class="guide-table-rule"
          :default-sort="{prop: 'updateTime', order: 'descending'}"
          :header-cell-class-name="headerCellClassName"
        >
        <template v-slot:useNum="{ row }">
           <gj-button type="text" @click="applyObject(row)">{{row.useNum | defaultShow}}</gj-button>
        </template>
        <!-- 规则 -->
        <template v-slot:expressionVO="{row}">{{getContent(row.expressionVO)}}</template>
        <!-- 模板状态（enabled：已开启，paused：已关闭，archived：已归档） -->
        <!-- <template v-slot:state="{ row }">
            <template
                v-if="row.state === 'archived'"
                color="#666666">已删除</template>
            <gj-switch
                v-else
                size="small"
                :value="row.state === 'enabled'"
            ></gj-switch>
        </template> -->
         <template #op="{index,row}">
              <template v-if="row.state !== 'archived'">
                <gj-button-group type="dropdown-op">
                  <gj-button type="text" @click="applyTemplate(row)" v-if="$permission('adsStrategyObject:add')"
>应用到</gj-button>
                  <template  #dropdown>
                    <gj-dropdown-item type="text" @click="handleEdit(row, 'copy')" v-if="$permission('adsStrategyTemplate:add')"
>复制</gj-dropdown-item>
                    <gj-dropdown-item type="text" @click="handleEdit(row, 'edit')" v-if="$permission('adsStrategyTemplate:update')"
>编辑</gj-dropdown-item>
                    <gj-dropdown-item type="text" @click="deleteItem(row)" v-if="$permission('adsStrategyTemplate:delete')">删除</gj-dropdown-item>
                    <gj-dropdown-item type="text" @click="operationLog(row)">日志</gj-dropdown-item>
                  </template>
                </gj-button-group>
              </template>
              <template v-else>
                <gj-button type="text" @click="operationLog(row)">日志</gj-button>
              </template>
          </template>
        </gj-table>
      </template>
    </app-base-main>
    <guide :guideData="guideData" ref="guideRef"></guide>
    </div>
</template>
<script>
import { isMeaningfulMixin, queryMixin } from '@/minxins';
import { template } from './data';
import { OpEnum, optionMap, getRuleContent } from '../const'
import { isMeaningful } from '@/utils/common';
import { getTemplateRuleData, autoRuleObjectData, editRuleTemplate } from '@/api/ad';
import adApplyTemplateModal from '../automatic-rule/ad-apply-template-modal.vue';
import adApplyObjectModal from '../automatic-rule/ad-apply-object-modal.vue';
import adOperationLogModal from '../automatic-rule/ad-operation-log-modal.vue';
import { mapGetters } from "vuex";
import guide from '../guide.vue'
import { guideData, objectAdsType } from './config';

export default {
  name: 'rule-template',
  components: {guide},
  inject: [ 'removeTab', 'getNavTabs'],
  mixins: [queryMixin, isMeaningfulMixin],
  computed: {
      ...mapGetters({
        userOptions: 'userOptions',
      }),
  },
  data() {
    return {
      guideData,
      optionMap,
      tableData: [
      
      ],
      columns: [
        { id: 'name',header: '模板名称',field: 'name',minWidth: '150px',sortable: true,},
        { id: 'adType', header: '广告类型', field: 'option:adType', minWidth: '80px',options:() => this.adList },
        { id: 'executeObjectAdsType', header: '优化对象', field: 'executeObjectAdsType', minWidth: '100px' },
        { id: 'useNum', header: '应用对象数', field: 'slot:useNum', minWidth: '80px', sortable: true,},
        { id: 'expressionVO', header: '规则', field: 'slot:expressionVO', minWidth: '300px' },
        // { id: 'state', header: '状态', field: 'slot:state', minWidth: '80px' },
        { id: 'updateTime', header: '最近更新时间', field: 'updateTime', minWidth: '120px', sortable: true,},
        { id: 'createUserId', header: '创建人', field: 'option:createUserId', minWidth: '80px', options: () => this.userOptions},
        { id: 'updateUserId', header: '更新人', field: 'option:updateUserId', minWidth: '80px', options: () => this.userOptions},
        { id: 'op', header: '操作', field: 'slot:op', width: '120px', fixed: 'right',notCustomColumn: true},
      ],
      filter: {
        name: '',
        createUserId: '',
        updateUserId: '',
      },
      activeName: 'second',
      // sp：商品广告，sb：品牌广告，sd：展示广告）
      adList: [
        { id: 'sp', text: '商品广告' },
        { id: 'sb', text: '品牌广告' },
        { id: 'sd', text: '展示广告' },
        ],
      helpName: 'timeadjuststrategy',
    };
  },
  created() {
    // 排序默认查询
    this.sort = {prop: 'updateTime', order: 'descending'};
  },
  methods: {
    // 添加模板
    add() {
      this.handleRouter(() => {
        this.$router.push({path: `/ad/add-rule-template`, query: {
            type: 'add',
            belong: 'template',
            sourceRoute: this.$route.path
        }})
      }, '新增自动模板规则')
    },
    // 路由跳转前处理
    handleRouter(callback, name) {
      const tabs = this.getNavTabs();
      if (tabs.some(item => item.name === name)) {
        this.removeTab(name);
        callback();
      } else {
        callback();
      }
    },
    $gjQueryInitParams() {
      return {
        filter: {
          name: '',
          createUserId: '',
          updateUserId: '',
        }
      };
    },
    $gjQuery() {
      // 构造查询参数
      const params = {
        model: {
          ...this.filter,
        },
        ...this.queryPagination,
        ...this.querySort,
      };
      // 查询
      this.loading = true;
      getTemplateRuleData(params)
        .then((data) => {
          if (isMeaningful(data)) {
            data.data.records.forEach(item => {
              item.executeObjectAdsType = objectAdsType[item.expressionVO.executeObjectAdsType]
            });
            this.tableData = data.data.records;
            this.pagination = this.getPagination(data.data);
             
          } else {
            this.tableData = [];
          }
        })
        .complete(() => {
          this.loading = false;
        });
    },
     //应用到对象
    applyObject(row) {
      this.$gjCreate(adApplyObjectModal, {
        props: {
          templateId: row.id,
          item: row,
        },
        on: {
          created: () => {
            this.$gjMessage.success('应用成功');
            this.$gjResetPage();
          },
          change: () => {
            this.$gjResetPage();
          }
        },
      });
    },
    //应用到
    applyTemplate(row) {
      const modal = this.$gjCreate(adApplyTemplateModal, {
        props: {
          templateId: row.id,
          executeObjectAdsType: row.expressionVO.executeObjectAdsType,
          strategyType: row.expressionVO.strategyType,
          item: row,
        },
        on: {
          submit: (data) => {
              if (data.length > 0) {
                modal.confirmLoading = true;
                var objectList = data.map((item) => {
                  return {
                    marketId: item.marketId,
                    adsType: item.adsType,
                    campaignId: item.campaignId,
                    applyObjectName: item.applyObjectName,
                    applyObjectId: item.applyObjectId,
                    applyObjectAdsType: item.applyObjectAdsType,
                  }
                });
                autoRuleObjectData({objectList: objectList, templateId: row.id}).then(data => {
                  console.log(data);
                  if (data.code == 0) {
                    //保存成功
                    this.$gjMessage.success('保存成功');
                    this.$gjResetPage();
                    modal.$gjDestroy();

                  }
                }).complete(() => modal.confirmLoading = false)

              }
          },
        }
      });
    },
    deleteItem(row) {
        const content =  row.useNum > 0 ?  `确定要删除[${row.name}]吗？一旦删除，关联应用对象的自动规则也会同时被删除掉！` : `确定要删除[${row.name}]吗？一旦删除不可恢复，请谨慎操作！`;
        const modal = this.$gjCreate('gj-info-modal', {
          props: {
            title: '删除确认',
            content
          },
          on: {
            cancel: () => modal.$gjDestroy(),
            confirm: () => {
              modal.confirmLoading = true;
              const list = [];
              const params = {
                id: row.id,
                name: row.name,
                state: 'archived',
              }
              list.push(params);
              editRuleTemplate(list).then(() => {
                    this.$gjMessage.success('删除成功');
                    this.$gjResetPage();
                    modal.$gjDestroy();
                })
                .complete(() => modal.confirmLoading = false);
            }
          }
        });
      },
          //操作日志
     operationLog(row) {
       console.log('id====',row.id);
      this.$gjCreate(adOperationLogModal, {
        props: {
          ruleId: row.id,
        },
        on: {
          created: () => {
            this.$gjMessage.success('应用成功');
            this.$gjResetPage();
          }
        }
      });
    },
    getContent(item) {
      return getRuleContent(item);
    },
    
    // 编辑 
    handleEdit(row, type) {
      this.handleRouter(() => {
        this.$router.push({path: type === 'edit' ? `/ad/add-rule-template/edit` : '/ad/add-rule-template', query: {
          id: row.id,
          type,
          belong: 'template',
          sourceRoute: this.$route.path
      }})
      },  type === 'edit' ? `编辑自动规则` : '新增自动模板规则')
    },
    headerCellClassName({ column }) {
      console.log()
      if (column.field === 'slot:op') {
        return 'guide-col-op'
      }
      return null
    },
    resize() {
      // setTimeout(() => {
      //   this.$refs.guideRef.start();
      // }, 20);
    }
  
  },
};
</script>

<style scoped lang="scss">
.rule-template-content {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.table-class {
  padding-top: 20px;
  flex: 1;
}
</style>
